import { Component } from '@angular/core';
import { NzGridModule } from 'ng-zorro-antd/grid';

@Component({
    selector: 'app-recruit-tips',
    templateUrl: './recruit-tips.component.html',
    styleUrls: ['./recruit-tips.component.scss'],
    imports: [NzGridModule]
})
export class RecruitTipsComponent {

}
